import {Injectable} from '@angular/core';
import {AbstractService} from './abstract.service';
import {ApiVersion} from '../constants/apis';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JobService extends AbstractService {

  constructor(private http: HttpClient) {
    super();
  }

  recalculateRetentions(libraryId: string): Observable<void> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'recalculation/library/' + libraryId);
    return this.http.get<void>(url);
  }
}
